import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import { getDimensionFullName } from '../constants';
import checkIcon from '../imgs/icons/icon_check.svg';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

const BubbleList = ({ list, className, heading }) => {
  return (
    <div className={`edu-bubble-group ${className}`}>
      <div className='bubble-heading'>{heading}</div>
      <div className='bubble-list'>
        {list.map(item => (
          <div key={item}>
            <div>
              <img src={checkIcon} alt='check' />
            </div>
            <div>{item}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
// "Influencia y Personas"
const InfluenciaYPersonas = () => (
  <>
    <p className='justified'>
      Si disfrutas estar con otras personas, trabajar en grupo y comunicarte con
      claridad, esta área puede ser la tuya. Las personas interesadas en
      Influencia y Personas suelen ser sociables, expresivas y con buena
      capacidad para relacionarse. Les gusta liderar, motivar y trabajar en
      equipo, y muchas veces logran convencer a otros de ideas o proyectos que
      consideran valiosos.
    </p>
    <p className='justified'>
      Tienen habilidades para comunicarse de forma clara y persuasiva, saben
      escuchar y entienden bien lo que los demás necesitan. Además, suelen ser
      empáticas y se sienten cómodas en ambientes dinámicos, donde puedan
      interactuar con distintas personas y generar impacto con su forma de ser y
      actuar.
    </p>
    <p className='justified'>
      Este interés se relaciona con trabajos que implican guiar a otros, vender
      ideas o productos, coordinar equipos o entregar servicios centrados en las
      personas. Son personas que conectan fácilmente con quienes las rodean, y
      eso las hace destacar en roles donde la comunicación, la colaboración y la
      influencia positiva son importantes
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como{' '}
      <strong>Ciencias Sociales, Derecho o Administración y Comercio</strong>.
      Algunos ejemplos de carreras afines en el área de Ciencias Sociales son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Ciencias Sociales'}
        list={['Periodismo', 'Publicidad y Relaciones Públicas', 'Psicología']}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Derecho'}
        list={['Derecho', 'Técnico Jurídico']}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Administración y Comercio'}
        list={[
          'Administración de Servicios',
          'Ingeniería Comercial',
          'Hotelería y Turismo'
        ]}
      />
    </div>
    <br />
  </>
);

// "Fabricación y Mecánica"
const FabricacionYMecanica = () => (
  <>
    <p className='justified'>
      Si te interesa cómo funcionan las cosas, te gusta construir, arreglar o
      diseñar objetos, y disfrutas trabajando con tus manos, esta área puede
      llamarte la atención. Las personas con este tipo de interés suelen ser
      prácticas, observadoras y detallistas. Les atrae el mundo físico, la
      tecnología, las herramientas y las soluciones concretas.
    </p>
    <p className='justified'>
      Tienen facilidad para entender sistemas y mecanismos, por lo que materias
      como física o tecnología les resultan interesantes. Les gusta crear,
      mejorar o reparar cosas, y sienten satisfacción al ver los resultados de
      su trabajo hecho realidad. Pueden destacar en actividades donde se
      necesita precisión, paciencia y ganas de resolver problemas prácticos.
    </p>
    <p className='justified'>
      Este interés se relaciona con tareas como diseñar o mantener maquinaria,
      fabricar productos, o desarrollar nuevas soluciones técnicas. También con
      pensar cómo hacer que algo funcione mejor. Son personas que valoran ver lo
      que logran con su esfuerzo y muchas veces prefieren trabajos donde puedan
      moverse, usar herramientas y aplicar sus ideas en proyectos reales.
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como <strong>Ciencias Básicas, Tecnología o Salud</strong>. Algunos
      ejemplos de carreras afines en el área de Ciencias Básicas son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Ciencias Básicas'}
        list={['Química Industrial', 'Geología', 'Astronomía']}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Tecnología'}
        list={[
          'Ingeniería Mecánica',
          'Ingeniería Civil Industrial',
          'Ingeniería Civil en Medio ambiente '
        ]}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Salud'}
        list={['Química y Farmacia', 'Tecnología Médica']}
      />
    </div>
    <br />
  </>
);

// "Liderazgo y Management"
const LiderazgoYManagement = () => (
  <>
    <p className='justified'>
      Si te gusta tomar la iniciativa, organizar a otros y lograr que las cosas
      funcionen bien, esta área puede interesarte. Las personas con este tipo de
      preferencia suelen ser prácticas, decididas y buenas para coordinar
      equipos. Disfrutan planificando tareas, guiando a otros y buscando
      resultados concretos.
    </p>
    <p className='justified'>
      Tienen facilidad para visualizar metas, tomar decisiones y encontrar
      maneras de hacer más eficiente el trabajo. Les va bien en situaciones
      donde hay que asumir responsabilidades, repartir funciones y mantener al
      grupo enfocado en cumplir objetivos. Les interesa que todo se haga de
      forma ordenada, clara y con buenos resultados.
    </p>
    <p className='justified'>
      Este interés se relaciona con roles donde hay que organizar proyectos,
      administrar recursos o dirigir personas, como ocurre en empresas,
      fundaciones, instituciones educativas u otras organizaciones. Suelen ser
      personas que comunican con claridad, inspiran confianza y están siempre
      pensando en cómo mejorar lo que ya existe. Les gusta asumir desafíos y se
      sienten cómodas liderando iniciativas que requieren coordinación y trabajo
      en equipo.
    </p>
    <p className='justified'>
      Hay muchas áreas donde se pueden desplegar roles de liderazgo y managment
      (desde un médico como gerente de salud de una clínca, hasta una escultora
      como directora de una galería de arte). Sin embargo, en general, las
      personas con este tipo de intereses tienden a buscar carreras en áreas
      como{' '}
      <strong>
        Ciencias Sociales, Tecnología, y Administración y Comercio
      </strong>
      . Algunos ejemplos de carreras afines en el área de Ciencias Sociales son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Ciencias Sociales'}
        list={[
          'Administración Pública',
          'Relaciones Públicas',
          'Ciencias Políticas'
        ]}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Tecnología'}
        list={[
          'Ingeniería Industrial',
          'Ingeniería en Control de Gestión',
          'Ingeniería en Logística'
        ]}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Administración y Comercio'}
        list={[
          'Ingeniería Comercial',
          'Administración de Empresas',
          'Ingeniería en Comercio Exterior'
        ]}
      />
    </div>
    <br />
  </>
);

// "Ciencias y Naturaleza"
const CienciaYNaturaleza = () => (
  <>
    <p className='justified'>
      Si te preguntas por qué ocurren las cosas en la naturaleza, te gusta
      observar el mundo que te rodea y buscar explicaciones lógicas, esta área
      puede ser muy interesante para ti. Las personas con este tipo de interés
      suelen ser curiosas, analíticas y metódicas. Les gusta entender cómo
      funcionan los fenómenos naturales, desde el cuerpo humano hasta los
      ecosistemas.
    </p>
    <p className='justified'>
      Disfrutan investigando, formulando hipótesis, buscando pruebas y
      analizando resultados. Pueden participar con entusiasmo en ferias
      científicas, proyectos de investigación o actividades al aire libre,
      porque disfrutan combinar lo que aprenden con la experiencia directa.
      Suelen ser buenas observadoras, atentas a detalles que otras personas
      podrían pasar por alto.
    </p>
    <p className='justified'>
      Este tipo de interés está relacionado con materias como biología, física,
      química o ciencias ambientales, y con actividades donde se explora, se
      investiga y se cuida el entorno. Estas personas valoran la biodiversidad,
      siguen con atención los avances científicos y sueñan con aportar al
      conocimiento o a la protección del planeta a través de lo que hagan en el
      futuro.
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como <strong>Agropecuaria, Ciencias Básicas, o Salud</strong>. Algunos
      ejemplos de carreras afines en el área Agropecuaria son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Agropecuaria'}
        list={['Agronomía', 'Medicina Veterinaria', 'Ingeniería Forestal']}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Ciencias Básicas'}
        list={['Bioquímica', 'Geología', 'Química o Licenciatura en Química']}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Salud'}
        list={['Medicina', 'Nutrición', 'Tecnología médica']}
      />
    </div>
    <br />
  </>
);
// "Administración y Proyectos"
const AdministracionYProyectos = () => (
  <>
    <p className='justified'>
      Si te gusta organizar cosas, planificar con tiempo y buscar formas de
      mejorar cómo funcionan los procesos, esta puede ser tu área. Las personas
      que se interesan en Administración y Proyectos suelen ser ordenadas,
      realistas y prácticas. Les gusta tener claridad sobre lo que hay que hacer
      y disfrutan cuando todo está bien estructurado. También son perseverantes,
      sobre todo cuando enfrentan desafíos o deben resolver problemas concretos.
    </p>
    <p className='justified'>
      Este tipo de interés está relacionado con tareas como evaluar procesos,
      estimar recursos, armar presupuestos, o planificar el uso del tiempo y del
      dinero. También incluye el gusto por trabajar con datos y tomar decisiones
      basadas en información clara.
    </p>
    <p className='justified'>
      En general, quienes se sienten atraídos por esta área valoran la
      precisión, los resultados concretos y el trabajo bien hecho. Pueden
      destacar en espacios donde se requiera coordinar personas y recursos, o en
      trabajos donde sea importante planificar, gestionar y hacer que las cosas
      funcionen de manera eficiente.{' '}
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como la{' '}
      <strong>Administración y Comercio, Ciencias Sociales o Tecnología</strong>
      . Algunos ejemplos de carreras afines en el área de Administración y
      Comercio son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Administración y Comercio'}
        list={[
          'Ingeniería Comercial',
          'Contador Auditor',
          'Administración de Empresas'
        ]}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Ciencias Sociales'}
        list={['Administración Pública', 'Psicología', 'Trabajo Social']}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Tecnología'}
        list={[
          'Ingeniería Civil Industrial',
          'Ingeniería en Control de Gestión',
          'Ingeniería en Logística'
        ]}
      />
    </div>
    <br />
  </>
);

// "Artes y Literatura"
const ArtesYLiteratura = () => (
  <>
    <p className='justified'>
      Si te interesa crear, expresarte de forma original o disfrutas observando
      el mundo desde una mirada distinta, esta área puede ser para ti. Las
      personas con este tipo de interés suelen tener una gran imaginación,
      sensibilidad y gusto por lo creativo. Les atrae lo nuevo, lo diferente, lo
      que no sigue siempre las reglas, y valoran mucho la belleza en sus
      distintas formas.
    </p>
    <p className='justified'>
      Pueden disfrutar de escribir, dibujar, actuar, sacar fotos, escuchar
      música o simplemente observar con atención lo que otros expresan. No
      siempre tienen habilidades artísticas específicas, pero sí una fuerte
      conexión con las emociones, el arte y las ideas originales. Les gusta
      explorar nuevos lenguajes y estilos, y a veces cuestionan lo establecido o
      buscan formas distintas de ver la realidad.
    </p>
    <p className='justified'>
      Este interés se relaciona con carreras y actividades donde se necesita
      creatividad, sensibilidad y pensamiento crítico. Lo importante para estas
      personas no es solo el resultado final, sino también el proceso de crear,
      imaginar y expresar lo que piensan o sienten a través del arte.
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como <strong>Arte y Arquitectura, Humanidades o Tecnología</strong>.
      Algunos ejemplos de carreras afines en el área de Arte y Arquitectura son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Arte y Arquitectura'}
        list={['Arquitectura', 'Diseño', 'Teatro, Música o Danza']}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Humanidades'}
        list={[
          'Letras y Literatura',
          'Traducción e Interpretación',
          'Filosofía'
        ]}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Tecnología'}
        list={['Diseño Industrial', 'Dibujo Técnico']}
      />
    </div>
    <br />
  </>
);

// "Soporte Social y Educación"
const SoporteSocialYEducacion = () => (
  <>
    <p className='justified'>
      Si te interesa ayudar a otros, escucharlos y entender lo que les pasa,
      esta área puede ser muy significativa para ti. Las personas con este tipo
      de interés suelen ser empáticas, atentas y comprometidas con el bienestar
      de quienes las rodean. Les nace acompañar a otros, ya sea dando apoyo
      emocional, compartiendo conocimientos o colaborando en proyectos que
      buscan mejorar la vida de las personas.
    </p>
    <p className='justified'>
      Suelen tener una gran capacidad para ponerse en el lugar del otro,
      reconocer lo que alguien necesita y actuar con respeto y sensibilidad. Les
      interesa entender cómo piensan y sienten los demás, y se preguntan por las
      causas de ciertos comportamientos o problemáticas sociales.
    </p>
    <p className='justified'>
      Este tipo de interés se relaciona con enseñar, orientar, acompañar o
      facilitar procesos de aprendizaje o cambio, tanto a nivel individual como
      grupal. Disfrutan siendo parte de espacios donde pueden aportar, cuidar y
      generar un impacto positivo. Son personas que valoran el respeto, la
      colaboración y el crecimiento de las personas y comunidades.
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como <strong>Ciencias Sociales, Derecho, Educación o Salud</strong>.
      Algunos ejemplos de carreras afines en el área de Ciencias Sociales son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Ciencias Sociales'}
        list={['Psicología', 'Trabajo Social', 'Sociología']}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Educación'}
        list={['Pedagogías', 'Educación de Párvulos', 'Psicopedagogía']}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Salud'}
        list={['Fonoaudiología', 'Terapia Ocupacional', 'Enfermería']}
      />
    </div>
    <br />
  </>
);

// "Ciencia de Datos"
const CienciaYDatos = () => (
  <>
    <p className='justified'>
      Si te gusta trabajar con números, analizar información y buscar patrones
      que ayuden a tomar decisiones, esta área puede ser ideal para ti. Las
      personas con este interés suelen ser ordenadas, analíticas y meticulosas.
      Les atrae resolver problemas complejos usando datos reales y confiables, y
      disfrutan cuando logran encontrar respuestas claras gracias al análisis de
      información.
    </p>
    <p className='justified'>
      Tienen facilidad para identificar relaciones entre distintos datos,
      organizar información y usar herramientas matemáticas o tecnológicas para
      interpretar lo que está pasando. Les interesa mucho la lógica y valoran la
      precisión, por lo que suelen ser detallistas y cuidadosos en sus procesos.
    </p>
    <p className='justified'>
      Este tipo de interés se relaciona con actividades como revisar bases de
      datos, analizar estadísticas, usar software especializado y generar
      conclusiones basadas en evidencia. Les motiva alcanzar resultados
      concretos y resolver desafíos a través de información bien estructurada.
      En general, son personas que disfrutan buscando respuestas objetivas y
      valoran mucho aprender nuevas herramientas que les ayuden a entender mejor
      el mundo a través de los datos.
    </p>
    <p className='justified'>
      Las personas con este tipo de intereses tienden a buscar carreras en áreas
      como{' '}
      <strong>Ciencias Básicas, Tecnología, o Administración y Comercio</strong>
      . Algunos ejemplos de carreras afines en el área de Ciencias Básicas son:
    </p>
    <br />
    <div className='edu-bubble-grid'>
      <BubbleList
        className={'bg-edu-yellow'}
        heading={'Ciencias Básicas'}
        list={[
          'Matemáticas ',
          'Astrofísica',
          'Ingeniería Civil en Ciencia de Datos'
        ]}
      />
      <BubbleList
        className={'bg-edu-green'}
        heading={'Tecnología'}
        list={[
          'Ingeniería en Computación e Informática',
          'Ingeniería en Estadística',
          'Técnico en Análisis de Sistemas'
        ]}
      />
      <BubbleList
        className={'bg-edu-blue'}
        heading={'Administración y Comercio'}
        list={[
          'Contador Auditor',
          'Ingeniería en Finanzas',
          'Ingeniería en Logística'
        ]}
      />
    </div>
    <br />
  </>
);

// const CN = 'Ciencias y Naturaleza';
// const FM = 'Fabricación y Mecánica';
// const CD = 'Ciencia de Datos';
// const AP = 'Administración y Proyectos';
// const AL = 'Artes y Literatura';
// const SE = 'Soporte Social y Educación';
// const IP = 'Influencia y Personas';
// const LM = 'Liderazgo y Management';

const VocationOneAreasDescriptionPage = ({
  user,
  background,
  dim,
  order,
  number,
  isLast
}) => {
  // const { TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4 } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  const dimName = getDimensionFullName(dim);
  // const secondDimName = getDimensionFullName(TOP_DIM_2);
  // const thirdDimName = getDimensionFullName(TOP_DIM_3);
  // const fourthDimName = getDimensionFullName(TOP_DIM_4);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>{`2.1.${order}. ${dimName}`}</h2>
          {dim === 'IP' && <InfluenciaYPersonas />}
          {dim === 'FM' && <FabricacionYMecanica />}
          {dim === 'LM' && <LiderazgoYManagement />}
          {dim === 'CN' && <CienciaYNaturaleza />}
          {dim === 'AP' && <AdministracionYProyectos />}
          {dim === 'AL' && <ArtesYLiteratura />}
          {dim === 'SE' && <SoporteSocialYEducacion />}
          {dim === 'CD' && <CienciaYDatos />}

          <br />
          <br />

          {isLast && (
            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', top: -45, left: -25 }}>
                <img
                  src={icono}
                  alt='icono binoculares'
                  style={{ width: 100, height: 'auto' }}
                />
              </div>
              <div className='edu-bubble-group bg-edu-red'>
                <p className='justified'>
                  Las carreras nombradas son solo algunos ejemplos. Existen
                  muchas más opciones relacionadas con tus intereses, así que te
                  invitamos a investigar carreras similares y a conocer mejor
                  las que más te llamaron la atención. Puedes buscar información
                  sobre qué se hace, qué se estudia, dónde se trabaja o dónde se
                  imparten distintas carreras. También puede ayudarte mucho
                  conversar con alguien que estudie o trabaje en la carrera que
                  te causa curiosidad.
                </p>
                <p className='justified'>
                  Este ejercicio de explorar, preguntar y conocer te servirá
                  para empezar a pensar con calma en lo que te gustaría hacer
                  más adelante.{' '}
                  <strong>
                    Aún tienes tiempo para reunir información y conocer
                    distintas alternativas y así poder tomar, en el futuro, una
                    decisión vocacional más informada y segura.
                  </strong>
                </p>
              </div>
            </div>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOneAreasDescriptionPage;
